/* eslint-disable no-nested-ternary */
import React, { useEffect, useState } from 'react';
import bcimage from '../../../../../assets/images/day_trado_success_active_account_and_plataform_bc_2.png';
import success from '../../../../../assets/svg-icons/success.svg';
import StarFilled from '../../../../../assets/svg-icons/StarFilled.svg';
import StarOutlined from '../../../../../assets/svg-icons/StarOutlined.svg';
import SmileOutlined from '../../../../../assets/svg-icons/SmileOutlined.svg';
import './style.scss';
import { trackingEvent } from 'data/usecases/tracking-event';
import { SuccessProps } from 'presentation/entities/success.entity';

export const DayTradeSuceesActiveAcccountAndPlataform = ({ course }: SuccessProps): JSX.Element => {
    const [note, selectNote] = useState(0);
    const notes = [1, 2, 3, 4, 5];
    const [sendNote, setSendNote] = useState(false);

    useEffect(() => {
        const savedNote = localStorage.getItem('tradeNoteCourse');

        if (savedNote !== null) {
            setSendNote(true);
        }
    }, []);
    return (
        <div
            className="col-sm-12 active_account_and_plataform_body"
            style={{
                backgroundImage: `url(${bcimage})`,
            }}
        >
            <div className="container">
                <div className=" text_content_active_account_and_plataform">
                    <div>
                        <div className="congradulations_active_account_and_plataform">
                            <img src={success} alt="" />
                            <p>PARABÉNS!</p>
                        </div>
                        <div className="title_active_account_and_plataform">
                            <h1>Você concluiu o curso Day Trade para Iniciantes</h1>
                            <p>
                                Agora você está preparado para operar em Day Trade. Acesse a Plataforma Profit Toro
                                Trader e opere junto com nossos especialistas na Live.
                            </p>
                        </div>
                    </div>
                    {!sendNote && (
                        <div className="star_active_account_and_plataform">
                            <p>Avalie o curso</p>

                            {notes.map((n, i) => (
                                <img
                                    src={note >= n ? StarFilled : StarOutlined}
                                    onMouseEnter={() => selectNote(n)}
                                    onMouseLeave={() => selectNote(0)}
                                    onClick={() => {
                                        localStorage.setItem('tradeNoteCourse', `${n}`);
                                        setSendNote(true);
                                        trackingEvent.elementClicked({
                                            productAreaOrigin: 'Aprenda',
                                            element: 'Avalie o curso',
                                            group: 'Tela de Conclusão do curso',
                                            step: 'Não se aplica',
                                            text: course?.name,
                                            timeResponsavel: 'Sky',
                                            specificProperties: {
                                                Avaliações: `${n}`,
                                            },
                                        });
                                    }}
                                    alt=""
                                    key={i}
                                />
                            ))}
                        </div>
                    )}
                    {sendNote && (
                        <div className="star_active_account_and_plataform">
                            <p>Agradecemos sua avaliação!</p>

                            <img src={SmileOutlined} alt="" />
                        </div>
                    )}
                    <div>
                        <a
                            href={'https://app.toroinvestimentos.com.br/plataformas/toro-trader'}
                            className="btn-next mb-2"
                            onClick={() => {
                                trackingEvent.elementClicked({
                                    productAreaOrigin: 'Aprenda',
                                    element: 'Começar a operar',
                                    group: 'Tela de Conclusão do curso',
                                    step: 'Não se aplica',
                                    text: course?.name,
                                    timeResponsavel: 'Sky',
                                });
                            }}
                        >
                            Começar a operar
                        </a>
                        <a
                            href={
                                'https://app.toroinvestimentos.com.br/aprenda/operando-day-trade-com-mais-seguranca/1/1'
                            }
                            className="white_button_active_account_and_plataform"
                            onClick={() => {
                                trackingEvent.elementClicked({
                                    productAreaOrigin: 'Aprenda',
                                    element: 'Aprenda a operar com segurança',
                                    group: 'Tela de Conclusão do curso',
                                    step: 'Não se aplica',
                                    text: course?.name,
                                    timeResponsavel: 'Sky',
                                });
                            }}
                        >
                            Aprenda a operar com segurança
                        </a>
                    </div>
                </div>
            </div>
        </div>
    );
};
